var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg041Construction = function Svg041Construction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481 76c0-24.814-20.186-45-45-45s-45 20.186-45 45c0 19.53 12.578 36.024 30 42.237V151h-8.789l-150 150h77.578l150-150H451v-32.763c17.422-6.213 30-22.707 30-42.237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.211 301h78.578l150-150h-77.578zM90 151v-32.763c17.422-6.213 30-22.707 30-42.237 0-24.814-20.186-45-45-45S30 51.186 30 76c0 19.53 12.578 36.024 30 42.237V151H0v128.789L128.789 151z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421 301v60H90v-60h8.789l151-150h-78.578l-150 150H60v150H30v30h90v-30H90v-60h331v60h-30v30h90v-30h-30V301h61V172.211L382.211 301z"
  })));
};
export default Svg041Construction;